import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 20,
    type: CHECKLIST_ITEM_TYPE.COMPLETE_TREATMENT,
    manifestKey: 'COMPLETE_TREATMENT',

    try_it: {
        button_label: 'Complete Treatment',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'CompleteTreatmentCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { treatment_id: 'demo-treatment-001' },
        },
    },
    pre_flight_diff: [
        'Step 1: POST /treatments/{id}/treatment_closed/ — treatment closes',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'Lead status: TREATMENT_STARTED → CLOSED',
        '⚠ Step-2 drift is UNRECOVERABLE — if step 1 succeeds but step 2 fails, treatment is CLOSED but cell stays PENDING',
        '⚠ Retry of step 2 fires treatment_close again which rejects (already CLOSED) — permanent divergence',
        'Role gate: ADMIN or TCO only — USER role returns 403',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
